import OptionsLayout from "../layouts/OptionsLayout.jsx";
import {
	createLazyPage,
	flattenNestedRoutes,
	generateNestedRoutes,
	wrapElement,
} from "./utils.js";

const OptionsPage = createLazyPage("Options", "GeneralOptionsPage");
const FinanceOptionsPage = createLazyPage("Options", "FinanceOptionsPage");
const CustomizationOptionsPage = createLazyPage(
	"Options",
	"CustomizationOptionsPage",
);
const SecurityOptionsPage = createLazyPage("Options", "SecurityOptionsPage"); // ← NOVO

export const getOptionsRoutes = () => {
	return generateNestedRoutes("/options", wrapElement(OptionsLayout), [
		{
			path: "general",
			element: wrapElement(OptionsPage),
		},
		{
			path: "general/:tab",
			element: wrapElement(OptionsPage),
		},
		{
			path: "finance",
			element: wrapElement(FinanceOptionsPage),
		},
		{
			path: "finance/:tab",
			element: wrapElement(FinanceOptionsPage),
		},
		{
			path: "customization",
			element: wrapElement(CustomizationOptionsPage),
		},
		{
			path: "customization/:tab",
			element: wrapElement(CustomizationOptionsPage),
		},
		{
			path: "security",
			element: wrapElement(SecurityOptionsPage),
		},
		{
			path: "security/:tab",
			element: wrapElement(SecurityOptionsPage),
		},
	]);
};

export const optionsRoutes = flattenNestedRoutes(getOptionsRoutes());
